/**
 * Estado de un proveedor según la frescura de la última sync correcta.
 * La misma ventana (Onnautic 8 días, el resto 48 h) la usa el Inicio.
 * Sin sync correcta prima «Sin sincronizar», también si el alta está apagada.
 */

import { catalogSyncStaleMaxHours, isStaleSync } from '../catalog/catalogSyncFreshness';

export type SupplierFreshness = 'sync_fresh' | 'sync_stale' | 'unsynced' | 'inactive';

export function supplierFreshness(input: {
    slug: string;
    isActive: boolean;
    lastOkFinishedAt?: string | null;
    nowMs?: number;
}): SupplierFreshness {
    if (!input.lastOkFinishedAt) return 'unsynced';
    if (!input.isActive) return 'inactive';
    const maxHours = catalogSyncStaleMaxHours(input.slug);
    if (isStaleSync(input.lastOkFinishedAt, maxHours, input.nowMs ?? Date.now())) return 'sync_stale';
    return 'sync_fresh';
}
